/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseDocumentsAvailableDocuments200,
  GetApiV1DocumentCourseDocumentsAvailableDocuments401,
  GetApiV1DocumentCourseDocumentsAvailableDocuments500,
  GetApiV1DocumentCourseDocumentsAvailableDocumentsQueryParams,
  GetApiV1DocumentCourseDocumentsAvailableDocumentsQueryResponse,
} from "../../types/documentCourseDocumentsController/GetApiV1DocumentCourseDocumentsAvailableDocuments.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1DocumentCourseDocumentsAvailableDocumentsQueryParamsSchema =
  z
    .object({
      courseId: z.optional(z.coerce.number().int()),
      filter: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<GetApiV1DocumentCourseDocumentsAvailableDocumentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseDocumentsAvailableDocuments200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1DocumentCourseDocumentsAvailableDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseDocumentsAvailableDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocumentsAvailableDocuments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseDocumentsAvailableDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseDocumentsAvailableDocuments500>;

export const getApiV1DocumentCourseDocumentsAvailableDocumentsQueryResponseSchema =
  z.lazy(
    () => getApiV1DocumentCourseDocumentsAvailableDocuments200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseDocumentsAvailableDocumentsQueryResponse>;
